'use client'

import { PropsWithChildren } from 'react'

import { ErrorBoundary } from '@marketplace-web/shared/error-display'

import { incrementPageLoadFailureCounter, logHomeError } from '../utils/client-observability'
import useTabs from '../hooks/useTabs'
import ErrorModal from '../common/ErrorModal'

const HomeErrorBoundary = (props: PropsWithChildren<unknown>) => {
  const { currentTab } = useTabs()

  const trackBoundaryError = (boundaryError: Error | null) => {
    incrementPageLoadFailureCounter({ tab: currentTab.name, homepage_reason: 'boundary' })
    logHomeError(boundaryError)
  }

  return (
    <ErrorBoundary onError={trackBoundaryError} FallbackComponent={ErrorModal}>
      {props.children}
    </ErrorBoundary>
  )
}

export default HomeErrorBoundary
